webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(260);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "server", function() { return server; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "console", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jar", function() { return jar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "save", function() { return save; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backup", function() { return backup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "system", function() { return system; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "player", function() { return player; });


var server = new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('server', '/api');
var console = server.child('console');
var jar = new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('jar', '/api');
var version = new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('version', '/api');
var save = new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('save', '/api');
var backup = save.child('backup');
var system = new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('system', '/api');
var player = server.child('player');

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_CLICK", function() { return ADD_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFRESH_CLICK", function() { return REFRESH_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SERVER_START", function() { return SERVER_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SERVER_STOP", function() { return SERVER_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JAR_INSTALL", function() { return JAR_INSTALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_BACKUP", function() { return SAVE_BACKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_ROLLBACK", function() { return SAVE_ROLLBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_START_ROLLBACK", function() { return SAVE_START_ROLLBACK; });
/* harmony export (immutable) */ __webpack_exports__["connect"] = connect;
/* harmony export (immutable) */ __webpack_exports__["reconnect"] = reconnect;
/* harmony export (immutable) */ __webpack_exports__["disconnect"] = disconnect;
/* harmony export (immutable) */ __webpack_exports__["createEventSource"] = createEventSource;





var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
var ADD_CLICK = 'add-click';
var REFRESH_CLICK = 'refresh-click';

var es = void 0;

var SERVER_START = 'server-start';
var SERVER_STOP = 'server-stop';
var JAR_INSTALL = 'jar-install';
var SAVE_BACKUP = 'save-backup';
var SAVE_ROLLBACK = 'save-rollback';
var SAVE_START_ROLLBACK = 'save-start-rollback';

function handleSEEvent(event) {
  var data = JSON.parse(event.data);
  bus.$emit(event.type, data, event);
}

function connect() {
  es = createEventSource('/api/event');
  [SERVER_START, SERVER_STOP, JAR_INSTALL, SAVE_BACKUP, SAVE_ROLLBACK, SAVE_START_ROLLBACK].forEach(function (event) {
    es.addEventListener(event, handleSEEvent);
  });
}

function reconnect() {
  disconnect();
  connect();
}

function disconnect() {
  es.close();
}

function createEventSource(uri) {
  var parsedUrl = __WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(uri);
  if (!parsedUrl.hostname) {
    var defaultUrl = __WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.address);
    parsedUrl.hostname = defaultUrl.hostname;
    parsedUrl.port = defaultUrl.port;
    parsedUrl.protocol = defaultUrl.protocol;
  }
  var query = __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(parsedUrl.query);
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.enabled && (query.authorization = btoa(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.name + ':' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.pwd));
  parsedUrl.search = __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(query);
  uri = parsedUrl.format();
  return new EventSource(uri);
}

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_event__ = __webpack_require__(8);






var _this = this;






__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* default */]);

function updatePartial(type, selector) {
  return function (state, nValue) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state[type], selector(state[type], nValue), nValue);
  };
}

var store = new __WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* default */].Store({
  state: {
    address: localStorage.getItem('address'),
    auth: localStorage.getItem('auth') && JSON.parse(localStorage.getItem('auth')) || {
      user: '',
      pwd: '',
      enabled: false
    },
    version: {
      loading: false,
      loaded: false,
      versions: []
    },
    system: {
      version: '',
      node: ''
    },
    servers: [],
    jars: [],
    saves: [],
    autoRefresh: false,
    autoRefreshInterval: 3000
  },
  mutations: {
    updateAddress: function updateAddress(state, address) {
      state.address = address;
      localStorage.setItem('address', address);
    },
    updateAuth: function updateAuth(state, auth) {
      state.auth = auth;
      localStorage.setItem('auth', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(auth));
      if (auth.enabled) __WEBPACK_IMPORTED_MODULE_6_vue__["default"].http.headers.common['Authorization'] = 'Basic ' + btoa(auth.name + ':' + auth.pwd);
    },
    startUpdateVersion: function startUpdateVersion(state) {
      state.version.loading = true;
    },
    updateVersion: function updateVersion(state, versions) {
      state.version.versions = versions;
      state.version.loading = false;
      state.version.loaded = false;
    },
    update: function update(state, _ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      state[key] = value;
    },

    updateAServer: updatePartial('servers', function (list, value) {
      return list.findIndex(function (server) {
        return server.name === value.name;
      });
    }),
    updateASave: updatePartial('saves', function (list, value) {
      return list.findIndex(function (save) {
        return save.name === value.name;
      });
    }),
    updateAJar: updatePartial('jars', function (list, value) {
      return list.findIndex(function (jar) {
        return jar.version === value.version;
      });
    }),
    toggleAutoRefresh: function toggleAutoRefresh(state, bool) {
      if (bool === false || bool === true) {
        state.autoRefresh = bool;
      } else {
        state.autoRefresh = !state.autoRefresh;
      }
    },
    updateServerState: function updateServerState(state, server) {
      state.servers.forEach(function (s, i) {
        if (s.name === server.name) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(s, server);
        }
      });
    },
    updateSystemInfo: function updateSystemInfo(state, system) {
      state.system = system;
    }
  },
  actions: {
    loadingVersion: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref4, force) {
        var commit = _ref4.commit,
            state = _ref4.state;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!state.version.loaded) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!state.version.loading) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                commit('startUpdateVersion');
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__resource__["version"].index({}, { refresh: !!force });

              case 7:
                res = _context.sent;

                commit('updateVersion', res.data);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function loadingVersion(_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }(),

    fetch: function fetch(_ref5, resourceName) {
      var _this2 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = commit;
                _context2.t1 = resourceName + 's';
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__resource__[resourceName].index();

              case 4:
                _context2.t2 = _context2.sent.data;
                _context2.t3 = [_context2.t1, _context2.t2];
                (0, _context2.t0)('update', _context2.t3);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    startServer: function startServer(_ref6, serverName) {
      var _this3 = this;

      var dispatch = _ref6.dispatch,
          commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit('updateServerState', {
                  name: serverName,
                  status: 'starting'
                });
                _context3.next = 3;
                return dispatch('changeServerState', { serverName: serverName, action: 'start' });

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    stopServer: function stopServer(_ref7, serverName) {
      var _this4 = this;

      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit('updateServerState', {
                  name: serverName,
                  status: 'starting'
                });
                _context4.next = 3;
                return dispatch('changeServerState', { serverName: serverName, action: 'stop' });

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    changeServerState: function changeServerState(_ref8, _ref9) {
      var _this5 = this;

      var commit = _ref8.commit,
          state = _ref8.state,
          dispatch = _ref8.dispatch;
      var serverName = _ref9.serverName,
          action = _ref9.action;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var server, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                server = state.servers.find(function (server) {
                  return server.name === serverName;
                });

                if (server) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return', false);

              case 3:
                _context5.prev = 3;
                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__resource__["server"].update({ server: server.name }, {
                  status: action
                });

              case 6:
                res = _context5.sent;

                commit('updateServerState', res.data);
                __WEBPACK_IMPORTED_MODULE_8__lib_event__["bus"].$once(__WEBPACK_IMPORTED_MODULE_8__lib_event__['SERVER_' + action.toUpperCase()], function () {
                  return dispatch('fetch', 'server');
                });
                _context5.next = 16;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](3);
                _context5.next = 15;
                return dispatch('fetch', 'server');

              case 15:
                return _context5.abrupt('return', false);

              case 16:
                return _context5.abrupt('return', true);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[3, 11]]);
      }))();
    },
    fetchSystemInfo: function fetchSystemInfo(_ref10) {
      var _this6 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_7__resource__["system"].get({
                  system: 'info'
                }).then(function (res) {
                  commit('updateSystemInfo', res.data);
                });

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2__);
/* harmony export (immutable) */ __webpack_exports__["a"] = byte2Size;
/* harmony export (immutable) */ __webpack_exports__["b"] = clone;


function byte2Size(byte) {
  var pos = ~~(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log2___default()(byte) / 10);
  return (byte / Math.pow(2, 10 * pos)).toFixed(2) + ' ' + 'BKMGT'[pos];
}

function clone(object) {
  if (object.slice) return object.slice();
  if (object.call) return object;
  if ((typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(object)) === 'object') {
    var o = {};
    for (var key in object) {
      if (object.hasOwnProperty(key)) o[key] = clone(object[key]);
    }
  }
  return object;
}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

module.exports = {
	"name": "minecraft-manager-web",
	"version": "0.2.1",
	"description": "minecraft-manager web-ui",
	"author": "XGHeaven <xgheaven@gmail.com>",
	"private": true,
	"scripts": {
		"dev": "node build/dev-server.js",
		"start": "node build/dev-server.js",
		"build": "node build/build.js",
		"unit": "cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run",
		"e2e": "node test/e2e/runner.js",
		"test": "npm run unit && npm run e2e",
		"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs",
		"deploy": "gh-pages -d dist"
	},
	"dependencies": {
		"element-ui": "^1.2.8",
		"path-to-regexp": "^1.7.0",
		"vue": "^2.2.2",
		"vue-resource": "^1.3.1",
		"vue-router": "^2.3.0",
		"vuex": "^2.3.0"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.2",
		"babel-core": "^6.22.1",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-istanbul": "^3.1.2",
		"babel-plugin-transform-runtime": "^6.22.0",
		"babel-preset-env": "^1.2.1",
		"babel-preset-stage-2": "^6.22.0",
		"babel-register": "^6.22.0",
		"chai": "^3.5.0",
		"chalk": "^1.1.3",
		"chromedriver": "^2.27.2",
		"connect-history-api-fallback": "^1.3.0",
		"copy-webpack-plugin": "^4.0.1",
		"cross-env": "^3.1.4",
		"cross-spawn": "^5.0.1",
		"css-loader": "^0.26.1",
		"eslint": "^3.14.1",
		"eslint-config-standard": "^6.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^2.0.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.14.1",
		"extract-text-webpack-plugin": "^2.0.0",
		"file-loader": "^0.10.0",
		"friendly-errors-webpack-plugin": "^1.1.3",
		"gh-pages": "^0.12.0",
		"html-webpack-plugin": "^2.28.0",
		"http-proxy-middleware": "^0.17.3",
		"inject-loader": "^2.0.1",
		"karma": "^1.4.1",
		"karma-coverage": "^1.1.1",
		"karma-mocha": "^1.3.0",
		"karma-phantomjs-launcher": "^1.0.2",
		"karma-phantomjs-shim": "^1.4.0",
		"karma-sinon-chai": "^1.2.4",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-spec-reporter": "0.0.26",
		"karma-webpack": "^2.0.2",
		"lolex": "^1.5.2",
		"mocha": "^3.2.0",
		"nightwatch": "^0.9.12",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^1.3.0",
		"ora": "^1.1.0",
		"phantomjs-prebuilt": "^2.1.14",
		"rimraf": "^2.6.0",
		"selenium-server": "^3.0.1",
		"semver": "^5.3.0",
		"shelljs": "^0.7.6",
		"sinon": "^2.1.0",
		"sinon-chai": "^2.8.0",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"url-loader": "^0.5.8",
		"vue-loader": "^11.1.4",
		"vue-style-loader": "^2.0.0",
		"vue-template-compiler": "^2.2.4",
		"vuex": "^2.3.0",
		"webpack": "^2.2.1",
		"webpack-bundle-analyzer": "^2.2.1",
		"webpack-dev-middleware": "^1.10.0",
		"webpack-hot-middleware": "^2.16.1",
		"webpack-merge": "^2.6.1"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"browserslist": [
		"> 1%",
		"last 2 versions",
		"not ie <= 8"
	]
};

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Main__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_nav_server_Index__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_nav_server_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_nav_server_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_nav_server_Server__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_nav_server_Server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_nav_server_Server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav_jar_Index__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav_jar_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_nav_jar_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nav_save_Index__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nav_save_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_nav_save_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_nav_save_Save__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_nav_save_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_nav_save_Save__);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'main',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Main___default.a,
    children: [{
      path: 'server',
      name: 'servers',
      component: __WEBPACK_IMPORTED_MODULE_4__components_nav_server_Index___default.a
    }, {
      path: 'server/:serverName',
      name: 'server',
      component: __WEBPACK_IMPORTED_MODULE_5__components_nav_server_Server___default.a
    }, {
      path: 'jar',
      name: 'jars',
      component: __WEBPACK_IMPORTED_MODULE_6__components_nav_jar_Index___default.a
    }, {
      path: 'save',
      name: 'saves',
      component: __WEBPACK_IMPORTED_MODULE_7__components_nav_save_Index___default.a
    }, {
      path: 'save/:saveName',
      name: 'save',
      component: __WEBPACK_IMPORTED_MODULE_8__components_nav_save_Save___default.a
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
  }]
});

router.beforeEach(function (to, from, next) {
  var server = localStorage.getItem('address');
  if (!server && to.name !== 'login') {
    return next('/login');
  }
  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  "data-v-589319ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-369e1999",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  "data-v-4cff1fe4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  "data-v-dfac12e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-3342ef80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(178)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  "data-v-0505b28c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(175),
  /* scopeId */
  "data-v-e8684be6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-34dc6f3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-4308acbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  "data-v-709b372c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-4a5f069c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  "data-v-609d99fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-48b788b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "system-info"
  }, [_c('section', [_c('header', [_vm._v("web:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('section', [_c('header', [_vm._v("server:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.system.version))])]), _vm._v(" "), _c('section', [_c('header', [_vm._v("node:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.system.node))])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.cpuPrompt,
      "placement": "right"
    }
  }, [_c('el-progress', {
    staticClass: "progress",
    attrs: {
      "percentage": _vm.cpuPercent,
      "textInside": true,
      "strokeWidth": 18
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.memPrompt,
      "placement": "right"
    }
  }, [_c('el-progress', {
    staticClass: "progress",
    attrs: {
      "percentage": _vm.memPercent,
      "textInside": true,
      "strokeWidth": 18
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.servers
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n        Empty\n      ")]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "Version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.status))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status !== 'stopped'
          },
          on: {
            "click": function($event) {
              _vm.$store.dispatch('startServer', scope.row.name)
            }
          }
        }, [_vm._v("Start\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status !== 'started'
          },
          on: {
            "click": function($event) {
              _vm.$store.dispatch('stopServer', scope.row.name)
            }
          }
        }, [_vm._v("Stop\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.removeServer(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'server',
                params: {
                  serverName: scope.row.name
                }
              })
            }
          }
        })]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Server"
    },
    model: {
      value: (_vm.addServerModal),
      callback: function($$v) {
        _vm.addServerModal = $$v
      },
      expression: "addServerModal"
    }
  }, [_c('el-form', {
    attrs: {
      "labelWidth": "120px"
    },
    model: {
      value: (_vm.newServerModal),
      callback: function($$v) {
        _vm.newServerModal = $$v
      },
      expression: "newServerModal"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Server Name"
    }
  }, [_c('el-input', {
    on: {
      "change": function($event) {
        _vm.sameWithServerName ? _vm.newServerModal.save = arguments[0] : ''
      }
    },
    model: {
      value: (_vm.newServerModal.name),
      callback: function($$v) {
        _vm.newServerModal.name = $$v
      },
      expression: "newServerModal.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Save Name"
    }
  }, [_c('el-select', {
    attrs: {
      "allowCreate": "",
      "filterable": "",
      "placeholder": "Please select or create"
    },
    model: {
      value: (_vm.newServerModal.save),
      callback: function($$v) {
        _vm.newServerModal.save = $$v
      },
      expression: "newServerModal.save"
    }
  }, _vm._l((_vm.saves), function(save) {
    return _c('el-option', {
      key: save.name,
      attrs: {
        "value": save.name,
        "label": save.name
      }
    })
  })), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.sameWithServerName),
      callback: function($$v) {
        _vm.sameWithServerName = $$v
      },
      expression: "sameWithServerName"
    }
  }, [_vm._v("Same with server name")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Version"
    }
  }, [_c('version-select', {
    model: {
      value: (_vm.newServerModal.version),
      callback: function($$v) {
        _vm.newServerModal.version = $$v
      },
      expression: "newServerModal.version"
    }
  })], 1), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    attrs: {
      "title": "Option"
    }
  }, [_c('server-option', {
    attrs: {
      "option": _vm.newServerModal.options
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.processing
    },
    on: {
      "click": function($event) {
        _vm.addServer()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.processing
    },
    on: {
      "click": function($event) {
        _vm.addServerModal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "defaultActive": "server",
      "uniqueOpened": true,
      "router": true,
      "theme": "dark"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/server"
    }
  }, [_vm._v("服务器管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/save"
    }
  }, [_vm._v("存档管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/jar"
    }
  }, [_vm._v("版本管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/setting"
    }
  }, [_vm._v("设置")])], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "data": _vm.saves
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usedFor",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'save',
                params: {
                  saveName: scope.row.name
                }
              })
            }
          }
        }, [_vm._v("Info")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "disabled": !!scope.row.usedFor
          },
          on: {
            "click": function($event) {
              _vm.removeSave(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }]
    ])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._l((_vm.value), function(value, key) {
    return [(value instanceof Object) ? [_c('div', {
      staticClass: "object-line"
    }, [_c('span', {
      staticClass: "object-key"
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('object-dump', {
      attrs: {
        "value": value
      }
    })] : _c('div', {
      staticClass: "object-line"
    }, [_c('span', {
      staticClass: "object-key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('span', {
      staticClass: "object-value"
    }, [_vm._v(_vm._s(value))])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-tab-pane",
    class: {
      active: _vm.active
    },
    on: {
      "click": function($event) {
        _vm.select()
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n  "), _c('div', {
    staticClass: "tab-right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "value": _vm.current
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Backup",
      "name": "backup"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Setting",
      "name": "setting"
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('save-' + _vm.current, {
    tag: "component"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('server-option', {
    attrs: {
      "option": _vm.option
    }
  }), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveServer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper-left"
  }, [_c('vertical-tab', {
    model: {
      value: (_vm.playerIndex),
      callback: function($$v) {
        _vm.playerIndex = $$v
      },
      expression: "playerIndex"
    }
  }, _vm._l((_vm.players), function(player, index) {
    return _c('vertical-tab-pane', {
      key: player.uuid,
      attrs: {
        "label": player.displayName,
        "name": index + ''
      }
    }, [_c('el-tag', {
      attrs: {
        "type": player.isOnline ? 'success' : 'gray'
      },
      slot: "right"
    }, [_vm._v(_vm._s(player.isOnline ? 'Online' : 'Offline'))])], 1)
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-right"
  }, [_c('el-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "OP"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.server.status !== 'started'
    },
    on: {
      "change": _vm.changeOp
    },
    model: {
      value: (_vm.player.isOp),
      callback: function($$v) {
        _vm.player.isOp = $$v
      },
      expression: "player.isOp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.player.isOnline ? 'success' : 'gray'
    }
  }, [_vm._v(_vm._s(_vm.player.isOnline ? 'Online' : 'Offline'))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('object-dump', {
    attrs: {
      "value": _vm._f("filterPlayer")(_vm.player),
      "indent": 0
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_vm._v("\n  Minecraft Manager\n")])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Please select minecraft version"
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.version),
      callback: function($$v) {
        _vm.version = $$v
      },
      expression: "version"
    }
  }, _vm._l((_vm.filterVersions), function(version) {
    return _c('el-option', {
      key: 'version',
      attrs: {
        "label": version.id,
        "value": version.id
      }
    }, [_c('span', [_vm._v(_vm._s(version.id))]), _vm._v(" "), _c('span', {
      staticClass: "optionSubTitle"
    }, [_vm._v(_vm._s(version.type))])])
  })), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.showSnapshot),
      callback: function($$v) {
        _vm.showSnapshot = $$v
      },
      expression: "showSnapshot"
    }
  }, [_vm._v("Snapshot")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.showOldVersion),
      callback: function($$v) {
        _vm.showOldVersion = $$v
      },
      expression: "showOldVersion"
    }
  }, [_vm._v("Old Version")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('loadingVersion', true)
      }
    }
  }, [_vm._v("Refresh")])], 1)
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header pinned"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('header-bar-left')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('header-bar-right')], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "main pinned"
  }, [_c('el-col', {
    staticClass: "full-height left-container",
    attrs: {
      "span": 4
    }
  }, [_c('nav-menu'), _vm._v(" "), _c('os-usage')], 1), _vm._v(" "), _c('el-col', {
    staticClass: "full-height",
    attrs: {
      "span": 20
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "rules": _vm.rules,
      "labelWidth": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "javaXms"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.javaXms),
      callback: function($$v) {
        _vm.option.javaXms = $$v
      },
      expression: "option.javaXms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "javaXmx"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.javaXmx),
      callback: function($$v) {
        _vm.option.javaXmx = $$v
      },
      expression: "option.javaXmx"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Gamemode"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.gamemode),
      callback: function($$v) {
        _vm.option.properties.gamemode = $$v
      },
      expression: "option.properties.gamemode"
    }
  }, _vm._l((_vm.present.gamemode), function(item, index) {
    return _c('el-radio-button', {
      key: "gamemode",
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Difficulty"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.difficulty),
      callback: function($$v) {
        _vm.option.properties.difficulty = $$v
      },
      expression: "option.properties.difficulty"
    }
  }, _vm._l((_vm.present.difficulty), function(item, index) {
    return _c('el-radio-button', {
      key: "gamemode",
      attrs: {
        "label": index
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PVP"
    }
  }, [_c('el-switch', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.option.properties.pvp),
      callback: function($$v) {
        _vm.option.properties.pvp = $$v
      },
      expression: "option.properties.pvp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Max Players"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 1,
      "max": 20,
      "showInput": ""
    },
    model: {
      value: (_vm.option.properties['max-players']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'max-players';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['max-players'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['max-players']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Seed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.option.properties['level-seed']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'level-seed';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['level-seed'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['level-seed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Server Port"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.option.properties['server-port']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'server-port';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['server-port'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['server-port']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Enable Command Block"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.option.properties['enable-command-block']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'enable-command-block';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['enable-command-block'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['enable-command-block']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "View Distance"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 3,
      "max": 16,
      "showInput": ""
    },
    model: {
      value: (_vm.option.properties['view-distance']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'view-distance';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['view-distance'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['view-distance']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Online Mode"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.option.properties['online-mode']),
      callback: function($$v) {
        var $$exp = _vm.option.properties,
          $$idx = 'online-mode';
        if (!Array.isArray($$exp)) {
          _vm.option.properties['online-mode'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "option.properties['online-mode']"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-form', {
    staticClass: "header-info",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.server.name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Version"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.server.version) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', [_vm._v(_vm._s(_vm.server.status))]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": this.server.status !== 'stopped',
      "loading": this.server.status === 'starting'
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('startServer', _vm.server.name)
      }
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "disabled": this.server.status !== 'started',
      "loading": this.server.status === 'stopping'
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('stopServer', _vm.server.name)
      }
    }
  }, [_vm._v("Stop")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": _vm.current
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Console",
      "name": "console"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Player",
      "name": "player"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Setting",
      "name": "setting"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "component"
  }, [_c('keep-alive', [_c('server-' + _vm.current, {
    tag: "component",
    attrs: {
      "server": _vm.server
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "rules": _vm.rule
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Minecraft Manager")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "url",
      "auto-complete": "off",
      "placeholder": "Server Address"
    },
    model: {
      value: (_vm.model.address),
      callback: function($$v) {
        _vm.model.address = $$v
      },
      expression: "model.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Name",
      "disabled": !_vm.model.useAuth
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password",
      "disabled": !_vm.model.useAuth
    },
    model: {
      value: (_vm.model.pwd),
      callback: function($$v) {
        _vm.model.pwd = $$v
      },
      expression: "model.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Use Authorization"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.model.useAuth),
      callback: function($$v) {
        _vm.model.useAuth = $$v
      },
      expression: "model.useAuth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.createBackup()
      }
    }
  }, [_vm._v("Commit")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.getBackups()
      }
    }
  }, [_vm._v("Refresh")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.backups
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Size",
      "formatter": _vm.byte2Size,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "Time",
      "sortable": "",
      "formatter": _vm.parseTime
    }
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.rollback(scope.row)
            }
          }
        }, [_vm._v("Rollback")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteBackup(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }]
    ])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "console-container"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      staticClass: "console-line",
      class: [log.from]
    }, [_vm._v(_vm._s(log.log))])
  })), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.server.status !== 'started'
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitCommand()
      },
      "click": function($event) {
        _vm.alert(1)
      }
    },
    model: {
      value: (_vm.command),
      callback: function($$v) {
        _vm.command = $$v
      },
      expression: "command"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.server.status !== 'started'
    },
    on: {
      "click": function($event) {
        _vm.submitCommand()
      }
    },
    slot: "append"
  }, [_vm._v("Enter")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-tabs"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "global-action",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name === 'jars' || _vm.$route.name === 'servers'),
      expression: "$route.name === 'jars' || $route.name === 'servers'"
    }],
    attrs: {
      "icon": "plus",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bus.$emit(_vm.event.ADD_CLICK)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bus.$emit(_vm.event.REFRESH_CLICK)
      }
    }
  }, [_vm._v("Refresh")]), _vm._v(" "), _c('el-switch', {
    on: {
      "change": _vm.toggleAutoRefresh
    },
    model: {
      value: (_vm.autoRefresh),
      callback: function($$v) {
        _vm.autoRefresh = $$v
      },
      expression: "autoRefresh"
    }
  }), _vm._v(" "), _vm._v("\n       \n    ")], 1), _vm._v(" "), _c('el-col', {
    staticClass: "user-action",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n      Server: " + _vm._s(_vm.$store.state.address) + "\n      "), _c('el-button', {
    attrs: {
      "icon": "edit",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.jars
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "Version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.status === 'installed' ? 100 : (scope.row.download && parseInt(scope.row.download.percentage * 100) || 0),
            "status": scope.row.status === 'installed' ? 'success' : ''
          }
        })]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "disabled": scope.row.status !== 'uninstall',
            "loading": scope.row.status === 'installing',
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.installJar(scope.row)
            }
          }
        }, [_vm._v("Install\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status === 'installing',
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteJar(scope.$index)
            }
          }
        }, [_vm._v("\n            Delete\n          ")])], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Jar"
    },
    model: {
      value: (_vm.addJarModal),
      callback: function($$v) {
        _vm.addJarModal = $$v
      },
      expression: "addJarModal"
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.$store.state.version.loading),
      expression: "$store.state.version.loading"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Minecraft Version"
    }
  }, [_c('version-select', {
    model: {
      value: (_vm.newJarModal.version),
      callback: function($$v) {
        _vm.newJarModal.version = $$v
      },
      expression: "newJarModal.version"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.addJarModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.addingJar
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_index_styl__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_event__ = __webpack_require__(8);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    changeAutoRefresh: function changeAutoRefresh(bool) {
      var _this = this;

      if (this.autoRefresh && this.autoRefresh.call) {
        bool = bool || this.$store.state.autoRefresh;
        if (bool && !this._autoRefreshTimer) {
          this._autoRefreshTimer = setInterval(function () {
            return _this.autoRefresh();
          }, this.$store.state.autoRefreshInterval);
        } else if (!bool && this._autoRefreshTimer) {
          clearInterval(this._autoRefreshTimer);
          this._autoRefreshTimer = null;
        }
      }
    }
  },
  watch: {
    '$store.state.autoRefresh': function $storeStateAutoRefresh(bool) {
      this.changeAutoRefresh(bool);
    }
  },
  created: function created() {
    this.changeAutoRefresh();
    this.autoRefresh && this.autoRefresh.call && this.autoRefresh();
    this.autoRefresh && this.autoRefresh.call && __WEBPACK_IMPORTED_MODULE_8__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_8__lib_event__["REFRESH_CLICK"], this._refreshHandle = this.autoRefresh.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    if (this._autoRefreshTimer) {
      clearInterval(this._autoRefreshTimer);
      this._autoRefreshTimer = null;
    }
    if (this._refreshHandle) {
      __WEBPACK_IMPORTED_MODULE_8__lib_event__["bus"].$off(__WEBPACK_IMPORTED_MODULE_8__lib_event__["REFRESH_CLICK"], this._refreshHandle);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.auth.enabled) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Basic ' + btoa(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.auth.name + ':' + __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.auth.pwd);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path_to_regexp__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);







var Resource = function () {
  function Resource(name, prefix, parent) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Resource);

    if (prefix instanceof Resource) {
      parent = prefix;
      prefix = '';
    }
    this.name = name;
    this.parent = parent;
    if (this.parent instanceof Resource) {
      this.paramPath = this.indexPath = this.parent.paramPath + prefix;
    } else {
      this.paramPath = this.indexPath = prefix;
    }
    this.indexPath += '/' + name;
    this.paramPath += '/' + name + '/:' + name;
    this.compiledIndexPath = __WEBPACK_IMPORTED_MODULE_4_path_to_regexp___default.a.compile(this.indexPath);
    this.compiledParamPath = __WEBPACK_IMPORTED_MODULE_4_path_to_regexp___default.a.compile(this.paramPath);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Resource, [{
    key: 'index',
    value: function index(param, query) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(this.indexUrl(param, query));
    }
  }, {
    key: 'create',
    value: function create(param, data, query) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(this.indexUrl(param, query), data);
    }
  }, {
    key: 'get',
    value: function get(param, query) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(this.paramUrl(param, query));
    }
  }, {
    key: 'update',
    value: function update(param, data, query) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(this.paramUrl(param, query), data);
    }
  }, {
    key: 'delete',
    value: function _delete(param, query) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.delete(this.paramUrl(param, query));
    }
  }, {
    key: 'indexUrl',
    value: function indexUrl(param, query) {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.address + this.compiledIndexPath(param) + (query && '?' + __WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify(query) || '');
    }
  }, {
    key: 'paramUrl',
    value: function paramUrl(param, query) {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.address + this.compiledParamPath(param) + (query && '?' + __WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify(query) || '');
    }
  }, {
    key: 'child',
    value: function child(name) {
      this[name] = new Resource(name, this);
      return this[name];
    }
  }]);

  return Resource;
}();

/* harmony default export */ __webpack_exports__["a"] = (Resource);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_event__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_0__lib_event__["SAVE_BACKUP"], function (data) {
      if (data.result) {
        if (data.backup.id === 'latest') return;
        _this.$notify({
          title: 'Save Backup',
          message: 'save ' + data.save + ' backup ' + data.backup.id + ' success!',
          type: 'success'
        });
      } else {
        _this.$notify.error({
          title: 'Save Backup',
          message: 'save ' + data.save + ' Backup Error, try again later'
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_0__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_0__lib_event__["SAVE_ROLLBACK"], function (data) {
      if (data.result) {
        _this.$notify({
          type: 'success',
          title: 'Save Rollback',
          message: 'rollback to backup ' + data.backup.id + ' success for save ' + data.save
        });
      } else {
        _this.$notify.error({
          title: 'Save Rollback',
          message: 'rollback to backup ' + data.backup.id + ' failed for save ' + data.save
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_0__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_0__lib_event__["SERVER_START"], function (data) {
      if (data.result) {
        _this.$notify({
          type: 'success',
          title: 'Server Start',
          message: 'start server ' + data.server + ' success'
        });
      } else {
        _this.$notify.error({
          title: 'Server Start',
          message: 'start server ' + data.result + ' error'
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_0__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_0__lib_event__["SERVER_STOP"], function (data) {
      if (data.result) {
        _this.$notify({
          type: 'success',
          title: 'Server Stop',
          message: 'stop server ' + data.server + ' success'
        });
      } else {
        _this.$notify.error({
          title: 'Server Stop',
          message: 'stop server ' + data.result + ' error'
        });
      }
    });

    this.$store.dispatch('fetch', 'server');
    this.$store.dispatch('fetch', 'save');
    this.$store.dispatch('fetch', 'jar');
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: {
        address: this.$store.state.address,
        name: this.$store.state.auth.name,
        pwd: this.$store.state.auth.pwd,
        useAuth: this.$store.state.auth.enabled
      },
      rule: {
        address: {
          required: true,
          type: 'url',
          message: 'server url is invalid'
        },
        user: {
          validator: function validator(rule, value, cb) {
            cb();
          }
        },
        pwd: {}
      },
      logining: false
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.logining = true;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this.logining = false;
          return;
        }
        return _this.$http.get(_this.model.address + '/api/', {
          headers: _this.model.useAuth && {
            'Authorization': 'Basic ' + btoa(_this.model.name + ':' + _this.model.pwd)
          } || {}
        }).then(function () {
          _this.$store.commit('updateAddress', _this.model.address);
          _this.$store.commit('updateAuth', {
            name: _this.model.name,
            pwd: _this.model.pwd,
            enabled: _this.model.useAuth
          });

          _this.logining = true;
          _this.$router.push('/server');
        }).catch(function (res) {
          switch (res.status) {
            case 401:
              if (_this.model.useAuth) {
                _this.$message.error('name or password wrong');
              } else {
                _this.$message.error('please enable authorization');
              }
              break;
            default:
              _this.$message.error('server cannot acceptable');
          }
          _this.logining = false;
        });
      });
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_Left_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_Left_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_Left_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_Right_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_Right_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_Right_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_Menu_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_Menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__nav_Menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_OsUsage_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_OsUsage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__nav_OsUsage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_event__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__package_json__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderBarLeft: __WEBPACK_IMPORTED_MODULE_0__header_Left_vue___default.a,
    HeaderBarRight: __WEBPACK_IMPORTED_MODULE_1__header_Right_vue___default.a,
    NavMenu: __WEBPACK_IMPORTED_MODULE_2__nav_Menu_vue___default.a,
    OsUsage: __WEBPACK_IMPORTED_MODULE_3__nav_OsUsage_vue___default.a
  },
  watch: {
    '$store.state.system.version': function $storeStateSystemVersion(nValue) {
      if (nValue !== __WEBPACK_IMPORTED_MODULE_5__package_json___default.a.version) {
        this.$notify({
          type: 'warning',
          title: 'Version didn\'t match',
          message: 'Version didn\'t match, server is ' + nValue + ' but web ui is support ' + __WEBPACK_IMPORTED_MODULE_5__package_json___default.a.version + '. maybe have some bugs'
        });
      }
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_event__["connect"])();
    this.$store.dispatch('fetchSystemInfo');
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_event__["disconnect"])();
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ObjectDump',
  props: ['value']
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rules: {
        gamemode: {
          type: 'enum',
          'enum': [0, 1, 2, 3]
        },
        difficulty: {
          type: 'enum',
          enum: [0, 1, 2, 3]
        }
      },
      present: {
        gamemode: ['生存模式', '创造模式', '冒险模式', '旁观者模式'],
        difficulty: ['和平', '简单', '中等', '困难'],
        'view-distance': 10,
        'white-list': false,
        'online-mode': false,
        'level-seed': '',
        motd: 'A Minecraft Server'
      }
    };
  },

  props: ['option']
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showSnapshot: false,
      showOldVersion: false,
      version: ''
    };
  },

  props: ['value'],
  computed: {
    versions: function versions() {
      return this.$store.state.version.versions;
    },
    filterVersions: function filterVersions() {
      var _this = this;

      return this.$store.state.version.versions.filter(function (version) {
        if (version.type === 'release') return true;
        if (version.type === 'snapshot') return _this.showSnapshot;
        return _this.showOldVersion;
      });
    }
  },
  methods: {
    change: function change(value) {
      this.$emit('input', value);
    }
  },
  created: function created() {
    this.$store.dispatch('loadingVersion');
    this.version = this.value;
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  methods: {
    setActive: function setActive(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: String,
    name: String
  },
  data: function data() {
    return {};
  },

  computed: {
    active: function active() {
      return this.$parent.value === this.name;
    }
  },
  methods: {
    select: function select() {
      this.$parent.setActive(this.name);
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_event__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      event: __WEBPACK_IMPORTED_MODULE_1__lib_event__,
      bus: __WEBPACK_IMPORTED_MODULE_1__lib_event__["bus"],
      autoRefresh: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['toggleAutoRefresh']))
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_event__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__package_json__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__package_json__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      usage: {
        cpu: {
          user: 0, sys: 0, nice: 0, idle: 0, irq: 0
        },
        mem: {
          free: 0,
          total: 0,
          process: {
            rss: 0,
            heapTotal: 0,
            heapUsed: 0,
            external: 0
          }
        },
        loadavg: [0, 0, 0]
      },
      es: null,
      version: __WEBPACK_IMPORTED_MODULE_4__package_json___default.a.version
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['system']), {
    cpuPercent: function cpuPercent() {
      var cpu = this.usage.cpu;
      var used = cpu.user + cpu.sys + cpu.nice + cpu.irq;
      var total = used + cpu.idle;
      return ~~(used / total * 100);
    },
    memPercent: function memPercent() {
      var mem = this.usage.mem;
      return ~~((mem.total - mem.free) / mem.total * 100);
    },
    memPrompt: function memPrompt() {
      return 'Mem ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* byte2Size */])(this.usage.mem.total - this.usage.mem.free) + '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* byte2Size */])(this.usage.mem.total);
    },
    cpuPrompt: function cpuPrompt() {
      return 'CPU LoadAvg ' + this.usage.loadavg.map(function (v) {
        return v.toFixed(2);
      }).join(', ');
    }
  }),
  methods: {
    connect: function connect() {
      var _this = this;

      this.es = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_event__["createEventSource"])('/api/system?format=event');
      this.es.addEventListener('message', function (e) {
        _this.usage = JSON.parse(e.data).usage;
      });
    },
    disconnect: function disconnect() {
      this.es && this.es.close();
      this.es = null;
    }
  },
  created: function created() {
    this.connect();
  },
  beforeDestroy: function beforeDestroy() {
    this.disconnect();
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_event__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_VersionSelect__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_VersionSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_form_VersionSelect__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VersionSelect: __WEBPACK_IMPORTED_MODULE_5__components_form_VersionSelect___default.a },
  data: function data() {
    return {
      addJarModal: false,
      newJarModal: {
        version: ''
      },
      addingJar: false,
      version: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['jars'])),
  methods: {
    installJar: function installJar(jar) {
      __WEBPACK_IMPORTED_MODULE_1__resource__["jar"].update({
        jar: jar.version
      }, {
        status: 'install'
      }).then(function (res) {
        jar.status = res.data.status;

        var refresh = function refresh() {
          __WEBPACK_IMPORTED_MODULE_1__resource__["jar"].get({
            jar: jar.version
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(jar, 'download', res.data.download);
            jar.status = res.data.status;
            if (jar.status !== 'installed') setTimeout(refresh, 1000);
          });
        };

        setTimeout(refresh, 1000);
      });
    },
    deleteJar: function deleteJar(index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__resource__["jar"].delete({
        jar: this.jars[index].version
      }).then(function (res) {
        _this.jars.splice(index, 1);
      });
    },
    add: function add() {
      var _this2 = this;

      this.addingJar = true;
      __WEBPACK_IMPORTED_MODULE_1__resource__["jar"].create(null, this.newJarModal).then(function (res) {
        _this2.jars.push(res.data);
        _this2.newJarModal = {};
        _this2.addingJar = false;
        _this2.addJarModal = false;
        _this2.$message('Success');
      }, function (err) {
        _this2.addingJar = false;
        _this2.$message.error('Add Failed');
        console.error(err);
      });
    },
    autoRefresh: function autoRefresh() {
      this.$store.dispatch('fetch', 'jar');
    }
  },
  created: function created() {
    var _this3 = this;

    this._add = function () {
      _this3.newJarModal = { version: '' };
      _this3.addJarModal = true;
      _this3.$store.dispatch('loadingVersion');
    };
    __WEBPACK_IMPORTED_MODULE_3__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_3__lib_event__["ADD_CLICK"], this._add);
    this.autoRefresh();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__lib_event__["bus"].$off(__WEBPACK_IMPORTED_MODULE_3__lib_event__["ADD_CLICK"], this._add);
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(58);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      backups: [{
        id: '111123123',
        size: 1233322,
        createdTime: 12333239898
      }, {
        id: '111123123',
        size: 1233322,
        createdTime: 12333239898
      }, {
        id: '111123123',
        size: 1233322,
        createdTime: 12333239898
      }],
      saveName: this.$route.params.saveName
    };
  },

  computed: {
    nBackups: function nBackups() {
      return this.backups.map(function (backup) {
        var _backup = {};
        _backup.name = backup.name;
        _backup.size = (backup.size / 1024 / 1024).toFixed(2) + ' M';
        _backup.createdTime = new Date(backup.createdTime).toLocaleString();
        return _backup;
      });
    }
  },
  methods: {
    getBackups: function getBackups() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__resource__["backup"].index({
        save: this.saveName
      }).then(function (res) {
        _this.backups = res.data;
      });
    },
    createBackup: function createBackup() {
      var _this2 = this;

      this.$confirm('Will Create Backup. This will cause game slower on a moment', {
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__resource__["backup"].create({
          save: _this2.saveName
        });
      });
    },
    rollback: function rollback(backup) {
      var _this3 = this;

      this.$confirm('Are you want to rollback backup ' + backup.id + ', current snapshot will save in latest backup', {
        type: 'warning'
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__resource__["save"].update({
          save: _this3.saveName
        }, {
          backup: backup.id
        });
      }).then(function (res) {
        _this3.$message.success('Rollback to ' + backup.id + 'success');
      }, function (res) {
        _this3.$message.error('Rollback to ' + backup.id + 'failed');
      });
    },
    deleteBackup: function deleteBackup(backup) {
      var _this4 = this;

      this.$confirm('Do you want to delete backup ' + backup.id, {
        type: 'warning'
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__resource__["backup"].delete({
          save: _this4.saveName,
          backup: backup.id
        });
      }).then(function (res) {
        _this4.$message.success('Delete Success');
        _this4.getBackups();
      }, function (res) {
        _this4.$message.error('Delete Failed');
      });
    },
    byte2Size: function byte2Size(row, col) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* byte2Size */])(row[col.property]);
    },
    parseTime: function parseTime(row, col) {
      return new Date(row[col.property]).toLocaleString();
    }
  },
  created: function created() {
    this.getBackups();
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['saves'])),
  methods: {
    autoRefresh: function autoRefresh() {
      this.$store.dispatch('fetch', 'save');
    },
    removeSave: function removeSave(save) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["save"].delete({
        save: save.name
      }).then(function (res) {
        _this.$store.dispatch('fetch', 'save');
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backup_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Backup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Backup_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SaveBackup: __WEBPACK_IMPORTED_MODULE_1__Backup_vue___default.a },
  data: function data() {
    return {
      saveName: this.$route.params.saveName,
      save: {
        name: '',
        backups: []
      },
      current: 'backup'
    };
  },

  methods: {
    getSave: function getSave() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__resource__["save"].get({
        save: this.saveName
      }).then(function (res) {
        _this.save = res.data;
      });
    }
  },
  created: function created() {}
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_event__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['server'],
  data: function data() {
    return {
      logs: [],
      command: ''
    };
  },

  computed: {
    serverName: function serverName() {
      return this.$route.params.serverName;
    }
  },
  methods: {
    getLog: function getLog() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__resource__["console"].index({
        server: this.serverName
      }).then(function (res) {
        _this.logs = res.body.reverse();
      });
    },
    submitCommand: function submitCommand() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__resource__["console"].create({
        server: this.serverName
      }, {
        command: this.command
      }).then(function (res) {
        _this2.command = '';
        _this2.$message({
          type: 'success',
          message: 'Success'
        });
      });
    },
    scrollToEnd: function scrollToEnd() {
      var container = this.$el.querySelector('.console-container');
      container.scrollTop = container.scrollHeight;
    }
  },
  created: function created() {
    var _this3 = this;

    this.getLog();
    this._eventSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_event__["createEventSource"])('/api/server/' + this.serverName + '/console?format=event');
    this._eventSource.addEventListener('message', function (e) {
      _this3.logs.push(JSON.parse(e.data));
      _this3.scrollToEnd();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this._eventSource.close();
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_event__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_VersionSelect__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_VersionSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_form_VersionSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ServerOption__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ServerOption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_form_ServerOption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource__ = __webpack_require__(7);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VersionSelect: __WEBPACK_IMPORTED_MODULE_3__components_form_VersionSelect___default.a,
    ServerOption: __WEBPACK_IMPORTED_MODULE_4__components_form_ServerOption___default.a
  },
  data: function data() {
    return {
      addServerModal: false,
      newServerModal: {
        name: '',
        version: '',
        save: '',
        options: {
          javaXms: '256M',
          javaXmx: '1G',
          properties: {
            gamemode: 0,
            difficulty: 1,
            pvp: true,
            'enable-command-block': false,
            'max-players': 20,
            'server-port': 25565,
            'view-distance': 10,
            'white-list': false,
            'online-mode': false,
            'level-seed': 0,
            motd: 'A Minecraft Server'
          }
        }
      },
      sameWithServerName: true,
      processing: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['servers', 'saves'])),
  watch: {
    sameWithServerName: function sameWithServerName(nv, ov) {
      if (nv) this.newServerModal.save = this.newServerModal.name;
    }
  },
  methods: {
    autoRefresh: function autoRefresh() {
      this.$store.dispatch('fetch', 'server');
    },
    removeServer: function removeServer(server) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__resource__["server"].delete({
        server: server.name
      }).then(function (res) {
        _this.$store.dispatch('fetch', 'server');
        _this.$message({
          type: 'success',
          message: 'delete success, please delete save or jar manual'
        });
      });
    },
    addServer: function addServer() {
      var _this2 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_5__resource__["save"].create(null, {
        name: this.newServerModal.name
      }).then(function (res) {
        _this2.$message({
          type: 'success',
          message: 'save create success'
        });
        return __WEBPACK_IMPORTED_MODULE_5__resource__["jar"].create(null, {
          version: _this2.newServerModal.version
        });
      }).then(function (res) {
        _this2.$message({
          type: 'success',
          message: 'jar create success'
        });
        return __WEBPACK_IMPORTED_MODULE_5__resource__["server"].create(null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.newServerModal, {
          save: _this2.newServerModal.name
        }));
      }).then(function (res) {
        _this2.$message({
          type: 'success',
          message: 'server create success'
        });
        _this2.processing = false;
        _this2.addServerModal = false;
        _this2.$store.dispatch('fetch', 'server');
      }).catch(function (err) {
        console.log(err);
        _this2.$message.error('create error');
        _this2.processing = false;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this._add = function () {
      _this3.addServerModal = true;
    };
    __WEBPACK_IMPORTED_MODULE_2__lib_event__["bus"].$on(__WEBPACK_IMPORTED_MODULE_2__lib_event__["ADD_CLICK"], this._add);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__lib_event__["bus"].$off(__WEBPACK_IMPORTED_MODULE_2__lib_event__["ADD_CLICK"], this._add);
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_VerticalTab__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_VerticalTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_form_VerticalTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_VerticalTabPane__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_VerticalTabPane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_form_VerticalTabPane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ObjectDump__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_ObjectDump___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_form_ObjectDump__);








var filterPlayerKey = ['isOp', 'isOnline', 'displayName'];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { VerticalTab: __WEBPACK_IMPORTED_MODULE_2__components_form_VerticalTab___default.a, VerticalTabPane: __WEBPACK_IMPORTED_MODULE_3__components_form_VerticalTabPane___default.a, ObjectDump: __WEBPACK_IMPORTED_MODULE_4__components_form_ObjectDump___default.a },
  props: ['server'],
  data: function data() {
    return {
      players: [],
      playerIndex: '0'
    };
  },

  filters: {
    filterPlayer: function filterPlayer(value) {
      var player = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(player, value);
      filterPlayerKey.forEach(function (k) {
        return delete player[k];
      });
      return player;
    }
  },
  computed: {
    player: function player() {
      return this.players[this.playerIndex] || {};
    }
  },
  methods: {
    getPlayers: function getPlayers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__resource__["player"].index({
        server: this.server.name
      }).then(function (res) {
        _this.players = res.data;
      });
    },
    changeOp: function changeOp(op) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__resource__["console"].create({
        server: this.server.name
      }, {
        command: (op ? 'op ' : 'deop ') + this.player.displayName
      }).then(function () {
        _this2.$message({
          type: 'success',
          message: (op ? 'op ' : 'deop ') + 'success on ' + _this2.player.displayName
        });
      });
    },
    autoRefresh: function autoRefresh() {
      this.getPlayers();
    }
  },
  activated: function activated() {
    this.getPlayers();
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Console_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Console_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Console_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Setting_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Player_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Player_vue__);







var timer = null;
var interval = 1000;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ServerConsole: __WEBPACK_IMPORTED_MODULE_1__Console_vue___default.a, ServerSetting: __WEBPACK_IMPORTED_MODULE_2__Setting_vue___default.a, ServerPlayer: __WEBPACK_IMPORTED_MODULE_3__Player_vue___default.a
  },
  data: function data() {
    return {
      current: 'console'
    };
  },

  computed: {
    serverName: function serverName() {
      return this.$route.params.serverName;
    },
    server: function server() {
      var _this = this;

      return this.$store.state.servers.find(function (s) {
        return s.name === _this.serverName;
      }) || {};
    }
  },
  created: function created() {
    this.getServer();
  },

  methods: {
    getServer: function getServer() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__resource___["server"].get({ server: this.serverName }).then(function (res) {
        _this2.server = res.body;
      });
    },
    waiting: function waiting() {
      var _this3 = this;

      if (timer) return;
      var wait = function wait() {
        __WEBPACK_IMPORTED_MODULE_0__resource___["server"].get({ server: _this3.serverName }).then(function (res) {
          _this3.server = res.body;
          if (_this3.server.status !== 'started' || _this3.server.status !== 'stopped') {
            timer = setTimeout(wait, interval);
          } else {
            timer = null;
          }
        });
      };
      setTimeout(wait, interval);
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_form_ServerOption__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_form_ServerOption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_form_ServerOption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ServerOption: __WEBPACK_IMPORTED_MODULE_0__components_form_ServerOption___default.a
  },
  props: ['server'],
  data: function data() {
    return {
      option: __WEBPACK_IMPORTED_MODULE_1__lib_utils__["b" /* clone */](this.server.options)
    };
  },

  computed: {
    serverName: function serverName() {
      return this.$route.params.serverName;
    }
  },
  methods: {
    saveServer: function saveServer() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__resource__["server"].update({
        server: this.serverName
      }, {
        options: this.option
      }).then(function (res) {
        _this.$store.commit('updateAServer', res.body);
        _this.$message('Save Success');
      }).catch(function (res) {
        _this.$message.error('Save Error');
      });
    }
  },
  activated: function activated() {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[259]);


// WEBPACK FOOTER //
// static/js/app.6694e9e3c95504ec7ea3.js